import { TError, TExpertiseItem } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';

export const getExpertiseQueryKey = () => ['pro-directory', 'expertise'] as const;

export const useGetExpertiseQuery = () =>
  useQuery<TExpertiseItem[], TError>({
    queryKey: getExpertiseQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<TExpertiseItem[]>('pro-directory/expertise');
      return data;
    },
    staleTime: 1000 * 60 * 60, // 1h — static data
  });
